import { useCallback, useContext, useEffect, useState } from 'react';

import { FeatureFlagsContext } from './context';
import { FeatureFlagResultStatus } from './types';

interface FeatureFlagLoadingResult {
  value: boolean;
  status: FeatureFlagResultStatus.Loading;
  loading: true;
}

interface FeatureFlagLoadedResult {
  value: boolean;
  status: FeatureFlagResultStatus.Loaded;
  loading: false;
}

export type FeatureFlagResult = FeatureFlagLoadingResult | FeatureFlagLoadedResult;

export const useBooleanFeatureFlag = (key: string, defaultValue: boolean): FeatureFlagResult => {
  const featureFlagsContext = useContext(FeatureFlagsContext);
  const defaultResultState: FeatureFlagResult = {
    value: defaultValue,
    loading: true,
    status: FeatureFlagResultStatus.Loading,
  };
  const [result, setResult] = useState<FeatureFlagResult>(defaultResultState);

  const callback = useCallback((value: boolean): void => {
    setResult({
      value,
      status: FeatureFlagResultStatus.Loaded,
      loading: false,
    });
  }, []);

  useEffect(() => {
    featureFlagsContext.getBoolean(key, defaultValue, callback);
  }, [key, defaultValue, callback, featureFlagsContext]);
  return result;
};
